// @flow

import { connect } from 'react-redux';

import {
  selectCartIsCommitted,
  selectOneProduct,
  selectCartUUID as selectCartId,
} from '@gandi/cart';

import { getSetupOverviewUrl } from 'src/Cart/Setup/modules/helpers';
import { selectIsFavoriteContacts } from 'src/Cart/Setup/modules/selectors';

import type { FullState } from '../../../../../../types';

type Payload = {
  owner: any,
  admin?: any,
  tech?: any,
  bill?: any,
  ...
};

type ContactType = 'default' | 'favorite' | 'custom';

export type OwnProps = {
  productId: string | number,
};

type StateProps = {
  committed: boolean,
  contactType: ContactType,
  contactsChangeURL: string,
};

export type DomainContactsProps = {
  ...OwnProps,
  ...StateProps,
};

const getContactType = (
  payload?: Payload,
  favoriteContacts: boolean,
): ContactType => {
  if (!payload || (!payload.bill && !payload.tech && !payload.admin)) {
    return 'default';
  }

  if (favoriteContacts) {
    return 'favorite';
  }

  return 'custom';
};

const mapStateToProps = (state: FullState, ownProps: OwnProps): StateProps => {
  const product = selectOneProduct(state, {
    productId: ownProps.productId,
  }) || { process: undefined, payload: undefined };
  const { process, payload } = product;

  return {
    committed: selectCartIsCommitted(state),
    contactType: getContactType(
      payload,
      // $FlowFixMe process here is restrictive
      process ? selectIsFavoriteContacts(state, process) : false,
    ),
    // $FlowFixMe process here is restrictive
    contactsChangeURL: getSetupOverviewUrl(selectCartId(state), process),
  };
};

// $FlowFixMe[cannot-resolve-name]
// $FlowFixMe[incompatible-call]
export default (connect(mapStateToProps): Connector<
  mixed,
  OwnProps,
  // $FlowFixMe[cannot-resolve-name]
  MergeOPSP<OwnProps, StateProps, mixed>,
>);
